import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageTopicRevision({ topicId, revisionId }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addTopicRevisionNote(data = {}) {
    return privateFetch.post(`/v1/admin/topic/${topicId}/revision`, data);
  }

  function updateTopicRevisionNote({ revisionId, data }) {
    return privateFetch.put(`/v1/admin/topic/${topicId}/revision/${revisionId}`, data);
  }

  function deleteTopicRevisionNote({ revisionId } = {}) {
    return privateFetch.delete(`/v1/admin/topic/${topicId}/revision/${revisionId}`);
  }

  function manageTopicRevision(data) {
    if (data.type === 'UPDATE') {
      return updateTopicRevisionNote(data);
    }

    if (data.type === 'DELETE') {
      return deleteTopicRevisionNote(data);
    }

    return addTopicRevisionNote(data);
  }

  return useMutation(manageTopicRevision, {
    onSuccess(data) {
      console.log('🚀 ~ useManageTopicRevision ~ data:', data);
    },
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('revision-notes');
    },
  });
}

export default useManageTopicRevision;
